import React from 'react';

export default function ThemeSong() {
  return (
    // Main wrapper with full width, white background, hidden overflow, and drop shadow
    <div className='w-full bg-white overflow-hidden shadow-xl'>
      
      {/* Import Google Fonts (Amiri) and define a custom font class */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap');

          .font-amiri {
              font-family: 'Amiri', serif;
          }
        `}
      </style>

      {/* Central container with max width, padding, and flexbox for alignment */}
      <div className='max-w-2xl mx-auto px-4 py-20 flex flex-col items-center justify-center'>

        {/* Section: Title of the theme song */}
        <div className='z-30 relative text-center mb-10'>
          {/* First line of the title (larger font, dark blue color) */}
          <h1 className='font-amiri font-medium text-[#2B387D] text-6xl lg:text-7xl'>
            T H E M E
          </h1>
          {/* Second line of the title (smaller font, orange color for contrast) */}
          <h1 className='font-amiri font-medium text-[#E08000] text-3xl lg:text-5xl'>
            S O N G
          </h1>
        </div>

        {/* Section: Spotify Embed Player */}
        <div className='w-11/12 rounded-xl shadow-lg z- relative'>
          <iframe
            data-testid="embed-iframe"
            // Inline style to apply rounded corners
            style={{ borderRadius: '12px' }}
            // Spotify track embed link
            src="https://open.spotify.com/embed/track/0lYUu8iFs32C0ubnDvu4Ak?utm_source=generator"
            // Responsive full width, fixed height
            width="100%"
            height="352"
            // Remove border and allow fullscreen
            frameBorder="0"
            allowFullScreen=""
            // Allow Spotify player features: autoplay, copy, encryption, fullscreen, PiP
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            // Lazy load for performance optimization
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
